
import React from 'react'
import PropTypes from 'prop-types'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import DcpModal from './DcpModal'

const ActionModal = ({open, title, content, dismissText, onDismiss, buttons, styles}) => {
  const buttonSize = buttons ? (12/(buttons.length+1)) : 12
  return (
    <DcpModal styles={styles} open={open}>
      <Grid container>
        {title && (
          <Grid item xs={12}>
            <Typography variant="headline">
              {title}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="subheading">
            {content}
          </Typography>
        </Grid>
        <Grid item xs={buttonSize}>
          <Button
            color={buttons ? 'default' : 'primary'}
            onClick={onDismiss}
          >
            {dismissText}
          </Button>
        </Grid>
        {buttons && buttons.map((button, i) => (
          <Grid item xs={buttonSize} key={i}>
            {button}
          </Grid>
        ))}
      </Grid>
    </DcpModal>
  )
}

ActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.any,
  dismissText: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.element)
}

export default ActionModal


// WEBPACK FOOTER //
// ./src/components/common/ActionModal.js